/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Drawer, ListSubheader, ListItemText, ListItem, Grid, Typography, ListItemAvatar, Avatar, Divider, List } from '@mui/material'
import { Money, LocalGasStation, HighlightOff, DateRange, FileDownload } from '@mui/icons-material'
import { connect } from 'react-redux'
import IntlMessages from '../../util/IntlMessages'
import * as tools from '../../util/tools'
import useStyles from './styles'

function Details(props) {
    const anchor = 'bottom'
    const classes = useStyles()
    let title = tools.getSalesDetailsTitle(props.type)

    const getFuelRequestData = (obj) => {
        return (
            <List
                subheader={
                    <ListSubheader component="div">
                        {tools.miladiTojalali(obj.dtDate, 'timecount')}
                    </ListSubheader>
                }>
                <Grid container>
                    <Grid item xs={6} md={6}>
                        <ListItem>
                            <ListItemAvatar>
                                <Avatar sx={{ width: 35, height: 35 }}>
                                    <Money fontSize="small" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={<IntlMessages id="amount" />}
                                secondary={tools.numberformat(obj.iTotalPrice)} />
                        </ListItem>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <ListItem>
                            <ListItemAvatar>
                                <Avatar sx={{ width: 35, height: 35 }}>
                                    <LocalGasStation fontSize="small" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={<IntlMessages id="litrage" />}
                                secondary={tools.numberformat(obj.iTotalVolume)} />
                        </ListItem>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={6} md={6}>
                        <ListItem>
                            <ListItemAvatar>
                                <Avatar sx={{ width: 35, height: 35 }}>
                                    <FileDownload fontSize="small" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={<IntlMessages id="salesCount" />}
                                secondary={tools.numberformat(obj.iTotalCount)} />
                        </ListItem>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <ListItem>
                            <ListItemAvatar>
                                <Avatar sx={{ width: 35, height: 35 }}>
                                    <LocalGasStation fontSize="small" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={<IntlMessages id="tip" />}
                                secondary={tools.numberformat(obj.iTotalTipPrice)} />
                        </ListItem>
                    </Grid>
                </Grid>
                <Divider />
            </List>
        )
    }

    const getRefuelingData = (obj) => {
        return (
            <Grid>
                <Grid container>
                    <Grid item xs={6} md={6}>
                        <ListItem>
                            <ListItemAvatar>
                                <Avatar sx={{ width: 35, height: 35 }}>
                                    <DateRange fontSize="small" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={<IntlMessages id="date" />}
                                secondary={tools.miladiTojalali(obj.dtDate, 'time')} />
                        </ListItem>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <ListItem>
                            <ListItemAvatar>
                                <Avatar sx={{ width: 35, height: 35 }}>
                                    <LocalGasStation fontSize="small" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={<IntlMessages id="euro" />}
                                secondary={tools.numberformat(obj.iVolumeEuro)} />
                        </ListItem>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={6} md={6}>
                        <ListItem>
                            <ListItemAvatar>
                                <Avatar sx={{ width: 35, height: 35 }}>
                                    <LocalGasStation fontSize="small" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={<IntlMessages id="super" />}
                                secondary={tools.numberformat(obj.iVolumeSuper)} />
                        </ListItem>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <ListItem>
                            <ListItemAvatar>
                                <Avatar sx={{ width: 35, height: 35 }}>
                                    <LocalGasStation fontSize="small" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={<IntlMessages id="gasoline" />}
                                secondary={tools.numberformat(obj.iVolumeGasoline)} />
                        </ListItem>
                    </Grid>
                </Grid>
                <Divider />
            </Grid>
        )
    }

    return (
        <React.Fragment>
            <Drawer
                anchor={anchor}
                open={props.showDetails}
                onClose={() => props.setShowDetails()}
            >
                <Grid className={classes.root}>
                    <Grid container>
                        <Grid item xs={8} md={8}>
                            <Typography variant="h5">
                                {title}
                            </Typography>
                        </Grid>
                        <Grid item xs={4} md={4} className={classes.iconGrid}>
                            <HighlightOff onClick={() => props.setShowDetails()} />
                        </Grid>
                    </Grid>
                    <Divider />
                    <Grid className={classes.gridDetails}>
                        {props.details !== null && props.details.map((obj, index) => (
                            <Grid key={index}>
                                {props.type === 'fuel' ? getRefuelingData(obj) : getFuelRequestData(obj)}
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Drawer>
        </React.Fragment >
    )
}

const mapStateToProps = (state) => {
    return {
        details: state.field.details
    }
}

export default connect(mapStateToProps)(Details)